import React from 'react';
import { formatDateUS } from '../utils/dateFormat';

// Native date inputs follow the device locale, even with lang="en-US".
// Use an explicit US text field while keeping valid values in ISO for the API.
export function usDateToISO(value) {
  const match = String(value).match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (!match) return null;
  const [, month, day, year] = match;
  const date = new Date(Number(year), Number(month) - 1, Number(day));
  return date.getFullYear() === Number(year) && date.getMonth() + 1 === Number(month) && date.getDate() === Number(day)
    ? `${year}-${month}-${day}` : null;
}

export default function USDateInput({ value, onChange, ...props }) {
  const display = /^\d{4}-\d{2}-\d{2}$/.test(value || '') ? formatDateUS(value) : (value || '');
  return <input {...props} type="text" inputMode="numeric" placeholder="MM/DD/YYYY" aria-label={props['aria-label'] || 'Fecha (MM/DD/YYYY)'} maxLength={10} value={display}
    onChange={event => {
      const raw = event.target.value;
      event.target.setCustomValidity(raw && !usDateToISO(raw) ? 'Ingrese una fecha válida: MM/DD/YYYY (mes/día/año).' : '');
      onChange({ target: { value: usDateToISO(raw) || raw } });
    }} />;
}
